<template>
  <transition :name="initAnimation ? '' : `${animation}-${direction}`">
    <div
      v-show="display"
      v-bind="$attrs"
      class="slider-card"
      :class="{ small: $parent.small, }"
      :style="{
        transition: `all ${speed}s`,
        backgroundColor: background.color,
        backgroundImage: `url(${background.image})`,
      }"
      v-on="$listeners"
    >
      <template v-if="!$slots.custom">
        <div
          class="slider-card-body"
          :class="classCard"
        >
          <figure
            v-if="$slots['header-image']"
            class="header-image"
          >
            <!-- @slot Emplacement pour l'image en en-tête de la diapositive. -->
            <slot name="header-image" />
          </figure>

          <h1
            v-if="title.text"
            class="title bold"
            :style="`color: ${title.color}`"
          >
            {{ title.text }}
          </h1>

          <h2
            v-if="headline.text"
            class="headline light"
            :style="`color: ${headline.color}`"
          >
            {{ headline.text }}
          </h2>

          <h3
            v-if="description.text"
            class="description"
            :style="`color: ${description.color}`"
          >
            {{ description.text }}
          </h3>

          <div
            v-if="$slots.buttons"
            class="buttons-container"
          >
            <!-- @slot Emplacement des boutons -->
            <slot name="buttons" />
          </div>
        </div>

        <figure
          v-if="$slots.illustration"
          class="slider-card-illustration"
        >
          <!-- @slot Emplacement pour une illustration. -->
          <slot name="illustration" />
        </figure>
      </template>

      <!-- @slot Emplacement pour un contenu différent (ex : produits associés). -->
      <slot name="custom" />
    </div>
  </transition>
</template>

<script>
/**
 * Diapositive d'un carousel.
 * Tous les éléments sont définis dans l'admin Django. Il est possible de personnaliser les éléments suivants : logo,
 * titre (texte et couleur), sous-titre (texte et couleur), description (texte et couleur), bouton 1 (texte et lien),
 * bouton 2 (texte et lien), illustration, couleur de fond unie, image de fond.
 * Pour plus d'informations, voir le composant Slider.
 */
export default {
  name: "SliderCard",
  props: {
    /**
     * Titre de la diapositive.
     */
    title: {
      type: Object,
      default: () => ({ text: "", color: "#000000" }),
    },
    /**
     * En-tête de la diapositive.
     */
    headline: {
      type: Object,
      default: () => ({ text: "", color: "#000000" }),
    },
    /**
     * Description de la diapositive.
     */
    description: {
      type: Object,
      default: () => ({ text: "", color: "#000000" }),
    },
    /**
     * Couleur et image de fond.
     */
    background: {
      type: Object,
      default: () => ({ color: "#FFFFFFF", image: null }),
    },
    /**
     * Marchés pour lesquels sera visible le composant.
     */
    marches: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      display: false,
      isInit: false,
      initAnimation: false,
      direction: "right",
      animation: "normal",
      speed: 0.5,
    };
  },
  computed: {
    classCard() {
      return {
        center: !this.$slots.illustration,
        small: this.$parent.small,
        "h-center": !this.background.image,
      };
    },
  },
  created() {
    this.speed = this.$parent.speed || 0.5;
    this.animation = this.$parent.animation || "normal";
  },
  methods: {
    /**
     * Initialise l'animation du carousel.
     */
    init() {
      if (!this.isInit) {
        this.display = true;
        this.initAnimation = true;
        this.$nextTick(() => { this.initAnimation = false; });
      }
    },
    /**
     * Affiche une diapositive.
     * @param {String} direction Direction du changement de diapositives.
     */
    show(direction) {
      this.direction = direction;
      this.$nextTick(() => { this.display = true; });
    },
    /**
     * Cache une diapositive.
     * @param {String} direction Direction du changement de diapositives.
     */
    hide(direction) {
      this.direction = direction;
      this.$nextTick(() => { this.display = false; });
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/sliders/slider_card.scss";
</style>
